import React from 'react';

import { GlobalToken, theme } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { WarehouseFlowStatus } from '@app/models/orders';

export const statusColor = (status: string, token: GlobalToken): string =>
  ({
    [WarehouseFlowStatus.Planned]: token.colorTextQuaternary,
    [WarehouseFlowStatus.Picking]: token.colorWarning,
    [WarehouseFlowStatus.Assembled]: token.colorPrimary,
    [WarehouseFlowStatus.Shipped]: token.colorSuccess,
    [WarehouseFlowStatus.Cancelled]: token.colorTextQuaternary,
  }[status] || token.colorTextQuaternary);

interface IProps {
  // Складской статус - название из переводов
  status?: WarehouseFlowStatus;
  // Статус заказа - название задаёт заказчик в своём процессе
  name?: string;
}

export const OrderStatusTag: React.FC<IProps> = ({ status, name }) => {
  const { token } = theme.useToken();
  const ordersT = useTranslation(NSKeys.counterpartyOrders);

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '2px 10px',
        borderRadius: 6,
        background: token.colorPrimaryBg,
        color: token.colorText,
        fontSize: 13,
        whiteSpace: 'nowrap',
      }}
    >
      {status && <span style={{ width: 6, height: 6, borderRadius: '50%', background: statusColor(status, token) }} />}
      {name ?? (status && ordersT.t(`status.${status}` as const, { defaultValue: status }))}
    </span>
  );
};
